import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language/language.service';

@Component({
  selector: 'app-invoice-image',
  templateUrl: './invoice-image.page.html',
  styleUrls: ['./invoice-image.page.scss'],
})
export class InvoiceImagePage implements OnInit {
  slideIndex :any;
  model_data:any;
  constructor(private modalController : ModalController,) { }

  ngOnInit() {
    // console.log('modal_data', this.model_data)
  }
  closeModal(status){
    this.modalController.dismiss(status);
}
slideOpts = {
  initialSlide: 1,
  speed: 400,
  loop:true
  
  
};
slideLeft(slides){
 slides.slidePrev();
}
slideRight(slides){
  slides.slideNext();
}

}
